const ENDPOINTS = {
  TEST_REQUEST: '/test_request',
};

export default ENDPOINTS;